import { render, staticRenderFns } from "./bloodPressure.vue?vue&type=template&id=4c64b7b0&scoped=true&"
import script from "./bloodPressure.vue?vue&type=script&lang=js&"
export * from "./bloodPressure.vue?vue&type=script&lang=js&"
import style0 from "./bloodPressure.vue?vue&type=style&index=0&id=4c64b7b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64b7b0",
  null
  
)

export default component.exports